/**
 * El orden de hijos que exige el DTD de Gramps XML 1.7.2.
 *
 * Esto no es decoracion: si los elementos salen en otro orden el fichero NO
 * valida y Gramps lo rechaza. Las listas de aqui salen literalmente de
 * grampsxml.dtd y son la unica fuente de verdad al escribir.
 *
 * La pseudo-etiqueta "@fecha" representa el grupo alternativo
 * (daterange | datespan | dateval | datestr), que ocupa una sola posicion.
 */

/** Las cuatro formas de fecha. Solo puede aparecer una. */
export const ETIQUETAS_FECHA = [
  "daterange",
  "datespan",
  "dateval",
  "datestr",
] as const;

export const FECHA = "@fecha";

/**
 * Secciones de primer nivel de <database>, en el orden del DTD.
 *
 * OJO con dos trampas: <tags> va ANTES de <events>, y <citations>/<sources>
 * van ENTRE <families> y <places>. Es facil equivocarse porque el orden
 * "natural" al pensar en el modelo seria otro.
 */
export const ORDEN_DATABASE = [
  "header",
  "name-formats",
  "tags",
  "events",
  "people",
  "families",
  "citations",
  "sources",
  "places",
  "objects",
  "repositories",
  "notes",
  "bookmarks",
  "namemaps",
] as const;

/** Las secciones que modelamos. El resto se conserva en bruto. */
export const SECCIONES_MODELADAS = ["events", "people", "families", "places"] as const;

export const ORDEN_HEADER = ["created", "researcher", "mediapath"] as const;

export const ORDEN_PERSON = [
  "gender",
  "name",
  "eventref",
  "lds_ord",
  "objref",
  "address",
  "attribute",
  "url",
  "childof",
  "parentin",
  "personref",
  "noteref",
  "citationref",
  "tagref",
] as const;

export const ORDEN_FAMILY = [
  "rel",
  "father",
  "mother",
  "eventref",
  "lds_ord",
  "objref",
  "childref",
  "attribute",
  "noteref",
  "citationref",
  "tagref",
] as const;

export const ORDEN_EVENT = [
  "type",
  FECHA,
  "place",
  "cause",
  "description",
  "attribute",
  "noteref",
  "citationref",
  "objref",
  "tagref",
] as const;

export const ORDEN_NAME = [
  "first",
  "call",
  "surname",
  "suffix",
  "title",
  "nick",
  "familynick",
  "group",
  FECHA,
  "noteref",
  "citationref",
] as const;

export const ORDEN_PLACEOBJ = [
  "ptitle",
  "code",
  "pname",
  "coord",
  "placeref",
  "location",
  "objref",
  "url",
  "noteref",
  "citationref",
  "tagref",
] as const;

export const ORDEN_EVENTREF = ["attribute", "noteref", "citationref"] as const;

export const ORDEN_CHILDREF = ["citationref", "noteref"] as const;

/** Hijos de <person> que el modelo entiende; el resto va a `otros`. */
export const MODELADOS_PERSON = ["gender", "name", "eventref", "childof", "parentin"];
export const MODELADOS_FAMILY = ["rel", "father", "mother", "eventref", "childref"];
export const MODELADOS_EVENT = ["type", "place", "description", ...ETIQUETAS_FECHA];
export const MODELADOS_NAME = [
  "first",
  "call",
  "surname",
  "suffix",
  "title",
  "nick",
  "familynick",
  "group",
  ...ETIQUETAS_FECHA,
];
export const MODELADOS_PLACEOBJ = ["ptitle", "code", "pname"];
